import { render, staticRenderFns } from "./MobileProjectMaterial.vue?vue&type=template&id=158e2b4f&scoped=true"
import script from "./MobileProjectMaterial.vue?vue&type=script&lang=js"
export * from "./MobileProjectMaterial.vue?vue&type=script&lang=js"
import style0 from "./MobileProjectMaterial.vue?vue&type=style&index=0&id=158e2b4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_babel-core@7.0.0-bridge.0_@babel+core@7.29._80ed213f6ba743306e514f7b7b6c1c5b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158e2b4f",
  null
  
)

export default component.exports